class OwnersAutocomplete
  jQuery ->
    $('#filter_by_owner').autocomplete
      source: $('#filter_by_owner').data('autocomplete-source'),
      select: (event, ui) ->
        $.ajax(
          type: 'get',
          url: '/g7_spaces'
          success: ->
            $('#filter_by_owner').val(ui.item.label)
        )

module.exports = OwnersAutocomplete
